export default "__VITE_ASSET__DcdIi53V__"